import { render, staticRenderFns } from "./PostThumbnails.vue?vue&type=template&id=63d34afb&scoped=true&"
import script from "./PostThumbnails.vue?vue&type=script&lang=ts&"
export * from "./PostThumbnails.vue?vue&type=script&lang=ts&"
import style0 from "./PostThumbnails.vue?vue&type=style&index=0&id=63d34afb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d34afb",
  null
  
)

export default component.exports